<template>
  <!-- 기능 카드 편집 모달 -->
  <a-modal
    :visible="visible"
    :footer="null"
    :mask-closable="false"
    @cancel="handleCancel"
  >
    <template #title>
      <div class="modal-title">기능 카드 편집</div>
    </template>

    <div class="modal-content">
      <!-- 아이콘 이미지 -->
      <div class="feature-card-editor__field">
        <label class="feature-card-editor__label">아이콘 이미지</label>
        <image-uploader
          :model-value="localCard.icon"
          label=""
          :max-size-m-b="2"
          @update:model-value="(url) => (localCard.icon = url)"
        />
      </div>

      <!-- 카드 이름 (최대 20자) -->
      <div class="feature-card-editor__field">
        <label class="feature-card-editor__label">카드 이름 <span class="required">*</span></label>
        <a-input
          v-model:value="localCard.name"
          :maxlength="20"
          show-count
          placeholder="기능 이름 (최대 20자)"
        />
      </div>

      <!-- 설명 (최대 80자) -->
      <div class="feature-card-editor__field">
        <label class="feature-card-editor__label">설명 <span class="required">*</span></label>
        <a-textarea
          v-model:value="localCard.description"
          :maxlength="80"
          show-count
          :rows="3"
          placeholder="기능 설명 (최대 80자)"
        />
      </div>

      <!-- 링크 URL -->
      <div class="feature-card-editor__field">
        <label class="feature-card-editor__label">링크 URL</label>
        <a-input
          v-model:value="localCard.link"
          type="url"
          placeholder="https://..."
        />
      </div>

      <!-- 모달 푸터 -->
      <div class="modal-footer">
        <a-button @click="handleCancel">취소</a-button>
        <a-button type="primary" class="yellow-button" @click="handleSave">
          저장
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { message } from 'ant-design-vue';
import ImageUploader from '../common/ImageUploader.vue';

export default {
  name: 'FeatureCardEditor',

  components: {
    ImageUploader,
  },

  props: {
    // 모달 표시 여부
    visible: {
      type: Boolean,
      default: false,
    },
    // 편집할 카드 데이터 객체
    card: {
      type: Object,
      default: () => ({}),
    },
    // 카드 인덱스
    cardIndex: {
      type: Number,
      default: -1,
    },
  },

  emits: ['save', 'cancel'],

  data() {
    return {
      // props로 받은 카드 데이터의 로컬 복사본
      localCard: {
        icon: '',
        name: '',
        description: '',
        link: '',
      },
    };
  },

  watch: {
    // 모달이 열릴 때 카드 데이터 로컬 복사
    visible(val) {
      if (val) {
        this.localCard = {
          icon: this.card?.icon || '',
          name: this.card?.name || '',
          description: this.card?.description || '',
          link: this.card?.link || '',
        };
      }
    },
  },

  methods: {
    // 저장 처리: 필수 필드 유효성 검사 후 emit
    handleSave() {
      if (!this.localCard.name || this.localCard.name.trim() === '') {
        message.warning('카드 이름을 입력해주세요.');
        return;
      }
      if (!this.localCard.description || this.localCard.description.trim() === '') {
        message.warning('카드 설명을 입력해주세요.');
        return;
      }

      this.$emit('save', {
        card: { ...this.localCard },
        cardIndex: this.cardIndex,
      });
    },

    // 취소 처리
    handleCancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.feature-card-editor__field {
  margin-bottom: 16px;
}

.feature-card-editor__label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.required {
  color: #ff4d4f;
}
</style>
